<template>
<app-layout>
     <template v-slot:headerNav >
           
             <jet-nav-link
                :href="route('integrate.index')"
                :active="route().current('integrate.index')"
              >
                Integrate
              </jet-nav-link>
              <jet-nav-link
                :href="route('template.index')"
                :active="route().current('template.index')"
              >
                Template
              </jet-nav-link>
              <jet-nav-link
                :href="route('configurations.index')"
                :active="route().current('configurations.index')"
              >
                Settings
              </jet-nav-link>
     </template>
  <div class="grey-full">
    <h1 class="text-center text-green-400 text">
      Coming Soon
      </h1>
      <h2 class="text-center font-extrabold ">
       This Product is launching Soon
      </h2>
        <p class="text-center mt-3 text-gray-500">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Consequuntur quidem officia dolor.</p>
        <div class="container mt-14">
	<div class="container__item">
		<form class="form">
			<input type="email" required  class="form__field" placeholder="Your E-Mail Address" />
			<button class="btn btn--primary btn--inside uppercase">Send</button>
		</form>
	</div>
</div>
  </div>  
  </app-layout>
</template>
<script>
import AppLayout from '@/Layouts/tallyClinicAppLayout.vue';
import JetNavLink from '@/Jetstream/NavLink.vue'
export default {
  components:{
    AppLayout,
    JetNavLink
  },
  mounted(){
  }
}
</script>
<style>
.grey-full{
  padding:186px 0px ;
    background: #F3F4F6;
}
.text{
  /* margin-top: 200px; */
  font-weight: bolder;
}
/* .color{
 background-color: rgba(209, 250, 229,);
} */
:root {
  /* background: #f5f6fa;
  color: #9c9c9c; */
  font: 1rem "PT Sans", sans-serif;
}

a {
  color: inherit;
}
a:hover {
  color: #3cd49d;
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.uppercase {
  text-transform: uppercase;
}

.btn {
  display: inline-block;
  background: transparent;
  color: inherit;
  font: inherit;
  border: 0;
  outline: 0;
  padding: 0;
  transition: all 200ms ease-in;
  cursor: pointer;
}
.btn--primary {
  background: #3cd49d;
  color: #fff;
  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  padding: 12px 36px;
}
.btn--primary:hover {
  background: #3cd49d;
}
.btn--primary:active {
  background: #3cd49d;
  box-shadow: inset 0 0 10px 2px rgba(0, 0, 0, 0.2);
}
.btn--inside {
  margin-left: 16px;
}

.form__field {
  width: 360px;
  background: #fff;
  color: #a3a3a3;
  font: inherit;
  box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid gray;
  outline: 0;
  padding: 12px 15px;
}


</style>